import { Product } from "../../types/product";
import { Part } from "../Types/part";

export function mapPartToProduct(part: Part): Product {
  return {
    _id: part._id,
    title: part.title,
    price: part.price,
    imageUrl: part.images?.[0] || "",
    images: part.images || [],
    description: "Compatible vehicle part",
    category: "Car Parts",
    reviews: [],
  };
}
